export const fetchCurrentUser = (request, { signal, ...options } = {}) =>
  request({
    method: 'get',
    pathname: '/api/user/getcurrent',
    signal,
    ...options,
  });
